<template>
  <a-form
    layout="vertical"
    :model="form"
    ref="formRef"
    name="approve_user"
    class="user-form"
    :rules="validationsRules()"
    @finish="onSubmit"
  >
    <div class="row">
      <div class="col-sm-12">
        <a-form-item label="Select Organization" name="organization">
          <a-select
            class="w-100"
            show-search
            v-model:value="form.organization"
            placeholder="Select Organization"
            :options="organizations"
          ></a-select>
        </a-form-item>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <a-form-item label="Select Role" name="role">
          <a-select
            class="w-100"
            show-search
            v-model:value="form.role"
            placeholder="Select Role"
            :options="roles"
          ></a-select>
        </a-form-item>
      </div>
    </div>

    <div class="text-right">
      <a-button @click="onCancel()">
        Cancel
      </a-button>
      <a-button
        type="primary"
        html-type="submit"
        class="ml-2"
        :loading="loading"
      >
        Save
      </a-button>
    </div>
  </a-form>
</template>
<script>
import { mapActions } from 'vuex';

export default {
  props: ['organizations', 'roles', 'email'],
  emits: ['close'],
  data() {
    return {
      loading: false,
      form: {
        role: '',
        organization: '',
      },
    };
  },
  methods: {
    ...mapActions(['approveUser']),
    validationsRules() {
      return {
        role: [
          {
            required: true,
            trigger: 'change',
            message: 'role is required',
          },
        ],
        organization: [
          {
            required: true,
            trigger: 'change',
            message: 'Organization is required',
          },
        ],
      };
    },
    onSubmit() {
      this.loading = true;
      const data = {
        email: this.email,
        roleId: this.form.role,
        Organization_name: this.form.organization,
      };
      if (Object.values(data).length) {
        this.approveUser(data).then((res) => {
          this.loading = false;
          if (res === 'success') {
            this.$emit('close');
          }
        });
      }
    },
    onCancel() {
      this.$emit('close');
    },
  },
};
</script>
<style scoped></style>
